/* eslint-disable */

import * as THREE from 'three'

class PolygoneTexture
{
    /**
     * Constructor
     */
    constructor(options = {})
    {
        // Options
        this.debug = typeof options.debug !== 'undefined' ? options.debug : false
        this.resolution = typeof options.resolution !== 'undefined' ? options.resolution : 100
        this.shapes = typeof options.shapes !== 'undefined' ? options.shapes : []
        
        // Canvas
        this.canvas = document.createElement('canvas')
        this.canvas.width = this.resolution
        this.canvas.height = this.resolution

        // Debug
        if(this.debug)
        {
            this.canvas.style.position = 'absolute'
            this.canvas.style.top = 0
            this.canvas.style.left = 0
            this.canvas.style.zIndex = 1
            this.canvas.style.backgroundColor = 'black'
            document.body.appendChild(this.canvas)
        }

        // Context
        this.context = this.canvas.getContext('2d')

        // Each shape
        for(let j = 0; j < this.shapes.length; j++)
        {
            const _shape = this.shapes[j]

            this.context.strokeStyle = _shape.strokeStyle
            this.context.lineWidth = _shape.lineWidth
            this.context.beginPath()

            for(let i = 0; i < _shape.edgesCount + 1; i++)
            {
                const angle = i / _shape.edgesCount * Math.PI * 2 + _shape.angle
                const x = Math.cos(angle) * _shape.radius + this.resolution * 0.5
                const y = Math.sin(angle) * _shape.radius + this.resolution * 0.5

                if(i === 1)
                {
                    this.context.moveTo(x, y)
                }
                else
                {
                    this.context.lineTo(x, y)
                }
            }
            this.context.closePath()
            this.context.stroke()
        }

        // Texture
        this.texture = new THREE.Texture(this.canvas)
    }
}

export default PolygoneTexture



// WEBPACK FOOTER //
// ./src/scripts/components/page-home/Background/PolygoneTexture.js